"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7472],{

/***/ 39812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sy": function() { return /* binding */ PaginationContainer_bs_make; }
});

// UNUSED EXPORTS: Styles, makePagearray

// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_math.js + 1 modules
var js_math = __webpack_require__(53405);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Option.js
var belt_Option = __webpack_require__(72491);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/library/PaginationButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE








var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs/* rem */.hOB(1.25)),
    tl: {
        hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.midGrey */.Il.midGrey),
        tl: {
            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs/* rem */.hOB(0.625)),
            tl: {
                hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs/* rem */.hOB(0.625)),
                tl: {
                    hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(1.0)),
                    tl: {
                        hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(1.0)),
                        tl: {
                            hd: BsCss_bs/* media */.BC2("(max-width: 380px)", {
                                hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(0.8)),
                                tl: {
                                    hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(0.8)),
                                    tl: /* [] */ 0
                                }
                            }),
                            tl: {
                                hd: BsCss_bs/* border */.CgR(BsCss_bs.px(1), "solid", Theme_bs/* Color.lightGrey */.Il.lightGrey),
                                tl: {
                                    hd: BsCss_bs/* selector */.nZE("+ li", {
                                        hd: BsCss_bs/* unsafe */.K47("borderLeft", "0px"),
                                        tl: /* [] */ 0
                                    }),
                                    tl: /* [] */ 0
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var first = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* borderTopLeftRadius */.orU(BsCss_bs.px(10)),
    tl: {
        hd: BsCss_bs/* borderBottomLeftRadius */.AGO(BsCss_bs.px(10)),
        tl: /* [] */ 0
    }
});
var last = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* borderTopRightRadius */.E$t(BsCss_bs.px(10)),
    tl: {
        hd: BsCss_bs/* borderBottomRightRadius */.rfy(BsCss_bs.px(10)),
        tl: /* [] */ 0
    }
});
var disabled = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* important */.efO(BsCss_bs/* color */.$_Y(Theme_bs/* Color.lightGrey */.Il.lightGrey)),
    tl: {
        hd: BsCss_bs/* cursor */.ocY("auto"),
        tl: /* [] */ 0
    }
});
var selected = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* important */.efO(BsCss_bs/* color */.$_Y(Theme_bs/* Color.white */.Il.white)),
    tl: {
        hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.charcoal */.Il.charcoal),
        tl: /* [] */ 0
    }
});
var Styles = {
    container: container,
    first: first,
    last: last,
    disabled: disabled,
    selected: selected
};
var make = /*#__PURE__*/ react.memo(function(props) {
    var isLast = props.isLast;
    var isFirst = props.isFirst;
    var className = props.className;
    var title = props.title;
    var isDisabled = belt_Option/* getWithDefault */.tj(props.disabled, false);
    var isSelected = belt_Option/* getWithDefault */.tj(props.selected, false);
    var classNames = react.useMemo(function() {
        return Cn_bs/* make */.S([
            belt_Option/* getWithDefault */.tj(className, ""),
            belt_Option/* getWithDefault */.tj(isFirst, false) ? first : "",
            belt_Option/* getWithDefault */.tj(isLast, false) ? last : "",
            isSelected ? selected : "",
            container,
            isDisabled ? disabled : ""
        ]);
    }, [
        isFirst,
        isDisabled,
        props.large,
        isLast,
        isSelected
    ]);
    return jsx_runtime.jsx("li", {
        children: isDisabled || isSelected ? jsx_runtime.jsx("a", {
            children: title,
            "aria-label": title,
            "aria-selected": isSelected,
            disabled: true
        }) : jsx_runtime.jsx((link_default()), {
            href: props.href,
            prefetch: false,
            children: jsx_runtime.jsx("a", {
                children: title,
                "aria-label": title
            })
        }),
        className: classNames
    });
});
var Link$1;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/library/PaginationContainer.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var PaginationContainer_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("flex"),
    tl: /* [] */ 0
});
var PaginationContainer_bs_button = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* flex */.fUN({
        NAME: "num",
        VAL: 1.0
    }),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* justifyContent */.KlP("center"),
            tl: {
                hd: BsCss_bs/* maxWidth */.kkr(BsCss_bs/* rem */.hOB(4.75)),
                tl: /* [] */ 0
            }
        }
    }
});
var PaginationContainer_bs_Styles = {
    container: PaginationContainer_bs_container,
    button: PaginationContainer_bs_button
};
function makePagearray(currentPage, totalCount) {
    if (currentPage <= 3) {
        return [
            1,
            2,
            3,
            0,
            totalCount
        ];
    } else if (currentPage >= (totalCount - 2 | 0)) {
        return [
            1,
            0,
            totalCount - 2 | 0,
            totalCount - 1 | 0,
            totalCount
        ];
    } else {
        return [
            1,
            0,
            currentPage,
            0,
            totalCount
        ];
    }
}
var PaginationContainer_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var urlConstructor = props.urlConstructor;
    var currentPage = props.currentPage;
    var totalPages = js_math/* ceil */.mD(props.count / props.pageSize);
    var tmp;
    if (totalPages <= 5) {
        tmp = belt_Array/* makeBy */.KB(totalPages, function(i) {
            var pageStr = String(i + 1 | 0);
            return jsx_runtime.jsx(make, {
                title: pageStr,
                href: curry._1(urlConstructor, i + 1 | 0),
                selected: currentPage === (i + 1 | 0)
            }, "page_" + pageStr);
        });
    } else {
        var pages = makePagearray(currentPage, totalPages);
        tmp = belt_Array/* mapWithIndex */.Su(pages, function(idx, page) {
            return jsx_runtime.jsx(make, {
                title: page === 0 ? "..." : String(page),
                href: curry._1(urlConstructor, page),
                disabled: page === 0,
                selected: currentPage === page
            }, "page_" + String(idx));
        });
    }
    return jsx_runtime.jsx("nav", {
        children: jsx_runtime.jsxs("ul", {
            children: [
                jsx_runtime.jsx(make, {
                    title: "Back",
                    href: curry._1(urlConstructor, currentPage - 1 | 0),
                    disabled: (currentPage - 1 | 0) < 1,
                    className: PaginationContainer_bs_button,
                    isFirst: true,
                    large: true
                }),
                tmp,
                jsx_runtime.jsx(make, {
                    title: "Next",
                    href: curry._1(urlConstructor, currentPage + 1 | 0),
                    disabled: currentPage >= totalPages,
                    className: PaginationContainer_bs_button,
                    isLast: true,
                    large: true
                })
            ],
            className: Cn_bs/* make */.S([
                belt_Option/* getWithDefault */.tj(props.className, ""),
                PaginationContainer_bs_container
            ])
        }),
        "aria-label": "Pagination navigation",
        role: "navigation"
    });
});
 /* container Not a pure module */ 


/***/ }),

/***/ 22339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ Container_bs_make; }
});

// UNUSED EXPORTS: Styles

// EXTERNAL MODULE: ./src/bindings/BsCss.bs.js + 1 modules
var BsCss_bs = __webpack_require__(71863);
// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/curry.js
var curry = __webpack_require__(92592);
// EXTERNAL MODULE: ./src/css/Theme.bs.js
var Theme_bs = __webpack_require__(93802);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/auth/user/UserContext.bs.js
var UserContext_bs = __webpack_require__(81098);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/common/util.bs.js
var util_bs = __webpack_require__(7667);
// EXTERNAL MODULE: ./node_modules/rescript-classnames/src/Cn.bs.js
var Cn_bs = __webpack_require__(20859);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
;// CONCATENATED MODULE: ./src/components/pages/myAccount/NavItem.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100.0)),
    tl: {
        hd: BsCss_bs/* display */.jfB("flex"),
        tl: {
            hd: BsCss_bs/* flexDirection */.Me8("row"),
            tl: {
                hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs.px(10)),
                tl: {
                    hd: BsCss_bs/* paddingTop */.odA(BsCss_bs/* rem */.hOB(0.75)),
                    tl: {
                        hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs/* rem */.hOB(0.75)),
                        tl: {
                            hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(1.25)),
                            tl: {
                                hd: BsCss_bs/* cursor */.ocY("pointer"),
                                tl: /* [] */ 0
                            }
                        }
                    }
                }
            }
        }
    }
});
var highLighted = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.charcoal */.Il.charcoal),
    tl: {
        hd: BsCss_bs/* color */.$_Y(Theme_bs/* Color.white */.Il.white),
        tl: /* [] */ 0
    }
});
var leftIconContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* width */.bf$(BsCss_bs/* rem */.hOB(2.0)),
    tl: /* [] */ 0
});
var icon = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs.px(5)),
    tl: {
        hd: BsCss_bs/* marginRight */.wzR(BsCss_bs/* rem */.hOB(1.25)),
        tl: /* [] */ 0
    }
});
var tail = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* flex */.fUN({
        NAME: "num",
        VAL: 1.0
    }),
    tl: {
        hd: BsCss_bs/* textAlign */.ydu("right"),
        tl: /* [] */ 0
    }
});
var Styles = {
    container: container,
    highLighted: highLighted,
    leftIconContainer: leftIconContainer,
    icon: icon,
    tail: tail
};
var make = /*#__PURE__*/ react.memo(function(props) {
    var isHighlighted = props.isHighlighted;
    var title = props.title;
    var isHighlighted$1 = isHighlighted !== undefined ? isHighlighted : false;
    return jsx_runtime.jsx("li", {
        children: jsx_runtime.jsx((link_default()), {
            href: props.route,
            prefetch: false,
            children: jsx_runtime.jsxs("a", {
                children: [
                    jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: props.icon,
                            className: icon
                        }),
                        className: leftIconContainer
                    }),
                    util_bs/* ReactStuff.s */.p_.s(title),
                    isHighlighted$1 ? jsx_runtime.jsx("div", {
                        children: jsx_runtime.jsx(index_es.FontAwesomeIcon, {
                            icon: [
                                "fas",
                                "angle-right"
                            ],
                            className: icon
                        }),
                        className: tail
                    }) : null
                ],
                "aria-label": title,
                "aria-selected": isHighlighted$1,
                className: Cn_bs/* make */.S([
                    container,
                    isHighlighted$1 ? highLighted : ""
                ])
            })
        })
    });
});
var Link$1;
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/belt_Array.js
var belt_Array = __webpack_require__(96533);
;// CONCATENATED MODULE: ./src/components/pages/myAccount/LogoutButton.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE







var LogoutButton_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.white */.Il.white),
    tl: {
        hd: BsCss_bs/* borderRadius */.E0l(BsCss_bs/* rem */.hOB(2.0)),
        tl: {
            hd: BsCss_bs/* marginTop */.E9m(BsCss_bs/* rem */.hOB(1.5)),
            tl: {
                hd: BsCss_bs/* marginLeft */.oIA("auto"),
                tl: {
                    hd: BsCss_bs/* marginRight */.wzR("auto"),
                    tl: {
                        hd: BsCss_bs/* cursor */.ocY("pointer"),
                        tl: {
                            hd: BsCss_bs/* paddingTop */.odA(BsCss_bs/* rem */.hOB(0.5)),
                            tl: {
                                hd: BsCss_bs/* paddingBottom */.EtG(BsCss_bs/* rem */.hOB(0.7)),
                                tl: {
                                    hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(1.0)),
                                    tl: {
                                        hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs/* rem */.hOB(1.0)),
                                        tl: /* [] */ 0
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
});
var LogoutButton_bs_Styles = {
    container: LogoutButton_bs_container
};
var LogoutButton_bs_make = /*#__PURE__*/ react.memo(function(props) {
    return jsx_runtime.jsx((link_default()), {
        href: "/logout",
        prefetch: false,
        children: jsx_runtime.jsx("div", {
            children: util_bs/* ReactStuff.s */.p_.s("Log out"),
            className: LogoutButton_bs_container
        })
    });
});
var LogoutButton_bs_Link$1;
 /* container Not a pure module */ 

;// CONCATENATED MODULE: ./src/components/pages/myAccount/LeftNavigation.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE










var LeftNavigation_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* display */.jfB("none"),
    tl: {
        hd: BsCss_bs/* media */.BC2("(min-width: 1288px)", {
            hd: BsCss_bs/* width */.bf$(BsCss_bs.px(320)),
            tl: {
                hd: BsCss_bs/* minWidth */.ihZ(BsCss_bs.px(220)),
                tl: {
                    hd: BsCss_bs/* display */.jfB("flex"),
                    tl: {
                        hd: BsCss_bs/* flexDirection */.Me8("column"),
                        tl: {
                            hd: BsCss_bs/* paddingRight */.WLm(BsCss_bs.px(30)),
                            tl: /* [] */ 0
                        }
                    }
                }
            }
        }),
        tl: /* [] */ 0
    }
});
var titleContainer = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs/* rem */.hOB(1.875)),
    tl: {
        hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs/* rem */.hOB(1.5)),
        tl: /* [] */ 0
    }
});
var h1 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs/* rem */.hOB(1.5)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs/* rem */.hOB(1.75)),
        tl: /* [] */ 0
    }
});
var h2 = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* fontSize */.JBY(BsCss_bs/* rem */.hOB(1.125)),
    tl: {
        hd: BsCss_bs/* lineHeight */.Nv8(BsCss_bs/* rem */.hOB(1.5)),
        tl: {
            hd: BsCss_bs/* marginBottom */.yl7(BsCss_bs/* rem */.hOB(1.0)),
            tl: /* [] */ 0
        }
    }
});
var hr = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* marginTop */.E9m(BsCss_bs/* rem */.hOB(1.0)),
    tl: {
        hd: BsCss_bs/* borderTopWidth */.fCW(BsCss_bs.px(1)),
        tl: {
            hd: BsCss_bs/* borderColor */.tvt(Theme_bs/* Color.lightGrey */.Il.lightGrey),
            tl: /* [] */ 0
        }
    }
});
var LeftNavigation_bs_Styles = {
    container: LeftNavigation_bs_container,
    titleContainer: titleContainer,
    h1: h1,
    h2: h2,
    hr: hr
};
var menuItems = [
    {
        title: "My orders",
        icon: [
            "fas",
            "gift"
        ],
        route: "/orders"
    },
    {
        title: "My reminders",
        icon: [
            "fas",
            "calendar-star"
        ],
        route: "/reminders"
    },
    {
        title: "My details",
        icon: [
            "far",
            "user"
        ],
        route: "/my-details"
    }
];
var LeftNavigation_bs_make = /*#__PURE__*/ react.memo(function(props) {
    var router = next_router.useRouter();
    var isHighlighted = react.useCallback(function(route) {
        return router.pathname.includes(route);
    }, [
        router.pathname
    ]);
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx("div", {
                children: jsx_runtime.jsx("h1", {
                    children: util_bs/* ReactStuff.s */.p_.s("Hi " + props.user.firstName),
                    className: h1
                }),
                className: titleContainer
            }),
            jsx_runtime.jsx("h2", {
                children: util_bs/* ReactStuff.s */.p_.s("My account"),
                className: h2
            }),
            jsx_runtime.jsx("nav", {
                children: jsx_runtime.jsx("ul", {
                    children: belt_Array/* map */.UI(menuItems, function(item) {
                        return jsx_runtime.jsx(make, {
                            title: item.title,
                            icon: item.icon,
                            route: item.route,
                            isHighlighted: curry._1(isHighlighted, item.route)
                        }, item.route);
                    })
                }),
                "aria-label": "My account navigation"
            }),
            jsx_runtime.jsx("hr", {
                className: hr
            }),
            jsx_runtime.jsx(LogoutButton_bs_make, {})
        ],
        className: LeftNavigation_bs_container
    });
});
 /* container Not a pure module */ 

// EXTERNAL MODULE: ./node_modules/@rescript/std/lib/es6/js_null_undefined.js
var js_null_undefined = __webpack_require__(11236);
;// CONCATENATED MODULE: ./src/components/pages/myAccount/Container.bs.js
// Generated by ReScript, PLEASE EDIT WITH CARE









var Container_bs_container = curry._1(BsCss_bs/* style */.oBv, {
    hd: BsCss_bs/* backgroundColor */.Czw(Theme_bs/* Color.paleGrey */.Il.paleGrey),
    tl: {
        hd: BsCss_bs/* width */.bf$(BsCss_bs/* pct */.hdZ(100.0)),
        tl: {
            hd: BsCss_bs/* display */.jfB("flex"),
            tl: {
                hd: BsCss_bs/* flex */.fUN({
                    NAME: "num",
                    VAL: 1.0
                }),
                tl: {
                    hd: BsCss_bs/* media */.BC2("(min-width: 1288px)", {
                        hd: BsCss_bs/* paddingLeft */.rv2(BsCss_bs/* rem */.hOB(1.875)),
                        tl: /* [] */ 0
                    }),
                    tl: /* [] */ 0
                }
            }
        }
    }
});
var Container_bs_Styles = {
    container: Container_bs_container
};
function Container(props) {
    var match = UserContext_bs.useUser(undefined);
    var user = match[0];
    var router = next_router.useRouter();
    var timer = {
        contents: null
    };
    react.useEffect(function() {
        js_null_undefined/* iter */.he(timer.contents, function(timer) {
            clearTimeout(timer);
        });
        timer.contents = setTimeout(function(param) {
            if (user) {
                return;
            } else {
                router.push("/login?redirecturl=" + router.route);
                return;
            }
        }, 100);
        return function(param) {
            js_null_undefined/* iter */.he(timer.contents, function(timer) {
                clearTimeout(timer);
            });
        };
    }, [
        user
    ]);
    if (!user) {
        return null;
    }
    var userInfo = user._0;
    return jsx_runtime.jsxs("div", {
        children: [
            jsx_runtime.jsx(LeftNavigation_bs_make, {
                user: userInfo
            }),
            curry._1(props.children, userInfo)
        ],
        className: Container_bs_container
    });
}
var Container_bs_make = Container;
 /* container Not a pure module */ 


/***/ })

}]);